var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestedTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 5.41659H2.125M9.16667 1.08325V3.24992M4.83333 1.08325V3.24992M5.375 8.66659L6.45833 9.74992L8.89583 7.31242M4.725 11.9166H9.275C10.1851 11.9166 10.6401 11.9166 10.9877 11.7395C11.2935 11.5837 11.5421 11.3351 11.6979 11.0293C11.875 10.6817 11.875 10.2267 11.875 9.31659V4.76659C11.875 3.8565 11.875 3.40146 11.6979 3.05385C11.5421 2.74809 11.2935 2.49949 10.9877 2.3437C10.6401 2.16659 10.1851 2.16659 9.275 2.16659H4.725C3.81491 2.16659 3.35987 2.16659 3.01227 2.3437C2.7065 2.49949 2.45791 2.74809 2.30211 3.05385C2.125 3.40146 2.125 3.8565 2.125 4.76659V9.31659C2.125 10.2267 2.125 10.6817 2.30211 11.0293C2.45791 11.3351 2.7065 11.5837 3.01227 11.7395C3.35987 11.9166 3.81491 11.9166 4.725 11.9166Z",
    stroke: "#6AAFDC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestedTime);
export default __webpack_public_path__ + "static/media/RequestedTime.4ccf93776bb054ef3254d5472ae91e19.svg";
export { ForwardRef as ReactComponent };